import { useSearch } from 'wouter'
import queryString from 'query-string'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Skeleton } from '@/components/ui/skeleton'
import { useDocumentPageQuery } from '@/pages/DocumentPage/queries'

export const DocumentVersionDropdown = () => {
  const search = useSearch()
  const queryParams = queryString.parse(search) as {
    cv?: string // cad version
    dv?: string // document version
  }
  const docPage = useDocumentPageQuery()

  const docVersions = docPage.data?.documentVersions ?? []
  const docVersion = docPage.data?.documentVersion ?? null
  const latestDocumentVersion = docPage.data?.latestDocumentVersion ?? null
  const currentDocVersionId = docVersion?.id ?? ''
  const projectId = docPage.data?.project.id ?? ''

  if (docPage.isLoading) {
    return <Skeleton className="w-[200px] h-10 bg-primary-30 rounded-full" />
  }

  return (
    <Select
      defaultValue={String(currentDocVersionId)}
      onValueChange={(selectedVersion) => {
        const matchingCadVersion = docVersions.find(
          (dv) => dv.id === selectedVersion,
        )?.cad_version

        const newQueryParams = queryString.stringify({
          ...queryParams,
          dv: selectedVersion,
          cv: matchingCadVersion,
        })
        window.location.href = `/p/${projectId}/document/${docPage.data?.documentId}/edit?${newQueryParams}`
      }}
    >
      <SelectTrigger className="w-[200px] bg-primary-40 text-white rounded-full px-5 focus:ring-0">
        <SelectValue placeholder="Select a document version" />
      </SelectTrigger>
      <SelectContent>
        {docVersions.map((version) => {
          return (
            <SelectItem key={version.id} value={String(version.id)}>
              {version.id === latestDocumentVersion?.id
                ? 'Unpublished'
                : version.name || `V${version.version_number || 1}`}
            </SelectItem>
          )
        })}
      </SelectContent>
    </Select>
  )
}
